import { useMutation } from '@tanstack/react-query';
import { useProfile } from '../../api';
import { authHeader, handleResponse } from '../../queryClient';
import { LoadingSimulation } from '../../types';
import { useActiveCompany } from '../../utils/useCompany';

/** Start standalone simulation */
export const useStartSimulation = ({
  onError,
  onSuccess,
}: {
  onError?: (error: Response) => void;
  onSuccess: (id: string) => void;
}) => {
  const activeCompany = useActiveCompany();
  const { profile } = useProfile();

  const {
    error: startSimulationError,
    isLoading: isStartingSimulation,
    mutate: startSimulation,
  } = useMutation<
    { sessionId: string },
    Response,
    {
      exercise: string | null;
      layout?: string;
      simulator: string;
      position: string | null;
      vessel: {
        vesselCode: string | null;
        vesselName: string | null;
      } | null;
    },
    Omit<LoadingSimulation, 'id'>
  >({
    // @ts-ignore No idea how to fix this error
    async mutationFn(requestData) {
      return fetch(`/api/session/schedule-and-start`, {
        body: JSON.stringify({
          companyId: activeCompany!.companyId,
          customerSimulatorId: requestData.simulator,
          exerciseId: requestData.exercise,
          isInstructorModeSession: true,

          users: [
            {
              assessmentStatus: 0,
              assignmentId: null,
              layoutSpec: requestData.layout
                ? {
                    companyId: activeCompany!.companyId,
                    id: requestData.layout,
                  }
                : null,
              userId: profile?.userId,
              position: requestData.position,
              vesselCode: requestData?.vessel?.vesselCode || null,
              vesselName: requestData?.vessel?.vesselName || null,
            },
          ],
        }),

        headers: { ...(await authHeader()), 'Content-Type': 'application/json' },
        method: 'POST',
      }).then(handleResponse);
    },
    onSuccess: response => {
      onSuccess(response.sessionId);
    },
    onError: error => {
      onError && onError(error);
    },
  });

  return {
    startSimulation,
    isStartingSimulation,
    startSimulationError,
  };
};
